import { ConnectionsView } from '@/features/connections';
import { useViewer } from '@/features/session';

export function ConnectionsPage() {
  const { workspace } = useViewer();
  return workspace ? <ConnectionsView workspace={workspace} /> : null;
}
